(function () {
  if (customElements.get('alto-upsell-collection')) return;

  class AltoUpsellCollection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.upsellReady === 'true') return;

      this.dataset.upsellReady = 'true';
      this.activeProduct = null;
      this.selectedVariant = null;
      this.currentSlide = 0;
      this.checkoutBusy = false;
      this.lastTrigger = null;
      this.galleryController = null;

      this.addEventListener('click', this.handleClick.bind(this));
      this.keydownHandler = this.handleKeydown.bind(this);
      document.addEventListener('keydown', this.keydownHandler);
      this.startCountdown();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.keydownHandler);
      window.clearInterval(this.countdownInterval);

      if (this.galleryController) this.galleryController.abort();
      document.body.classList.remove('alto-upsell-modal-open');
    }

    get modal() {
      return this.querySelector('[data-upsell-modal]');
    }

    handleClick(event) {
      const openButton = event.target.closest('[data-upsell-open]');

      if (openButton && this.contains(openButton)) {
        this.openProduct(openButton);
        return;
      }

      const copyButton = event.target.closest('[data-upsell-copy]');

      if (copyButton && this.contains(copyButton)) {
        this.copyCoupon(copyButton);
        return;
      }

      const closeButton = event.target.closest('[data-upsell-close]');

      if (closeButton && this.contains(closeButton)) {
        this.closeModal();
        return;
      }

      if (event.target.matches('[data-upsell-modal]')) {
        this.closeModal();
        return;
      }

      const previousButton = event.target.closest('[data-upsell-prev]');
      const nextButton = event.target.closest('[data-upsell-next]');
      const dotButton = event.target.closest('[data-upsell-dot]');
      const sizeButton = event.target.closest('[data-upsell-size]');
      const checkoutButton = event.target.closest('[data-upsell-checkout]');

      if (previousButton) this.showSlide(this.currentSlide - 1);
      if (nextButton) this.showSlide(this.currentSlide + 1);
      if (dotButton) this.showSlide(Number(dotButton.dataset.upsellDot));
      if (sizeButton) this.selectVariant(Number(sizeButton.dataset.variantId));
      if (checkoutButton) this.startYampiCheckout(checkoutButton);
    }

    handleKeydown(event) {
      if (!this.modal || this.modal.hidden) return;

      if (event.key === 'Escape') {
        this.closeModal();
      }
    }

    openProduct(button) {
      if (this.dataset.offerExpired === 'true' && this.dataset.disableAfterCountdown === 'true') return;

      const card = button.closest('[data-upsell-product-card]');
      const productData = card && card.querySelector('[data-upsell-product-json]');

      if (!productData) return;

      try {
        this.activeProduct = JSON.parse(productData.textContent);
      } catch (error) {
        console.error('[Alto Upsell] Dados do produto inválidos.', error);
        return;
      }

      this.lastTrigger = button;
      this.selectedVariant = null;
      this.currentSlide = 0;
      this.checkoutBusy = false;
      this.renderModal();

      this.modal.hidden = false;
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('alto-upsell-modal-open');

      const firstAvailable = this.activeProduct.variants.find((variant) => variant.available);
      const availableVariants = this.activeProduct.variants.filter((variant) => variant.available);

      if (firstAvailable && availableVariants.length === 1) {
        this.selectVariant(firstAvailable.id);
      }

      window.requestAnimationFrame(() => {
        const closeButton = this.modal.querySelector('[data-upsell-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    closeModal() {
      if (!this.modal || this.modal.hidden || this.checkoutBusy) return;

      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('alto-upsell-modal-open');

      if (this.galleryController) this.galleryController.abort();
      if (this.lastTrigger) this.lastTrigger.focus({ preventScroll: true });
    }

    renderModal() {
      const product = this.activeProduct;
      const modal = this.modal;

      if (!product || !modal) return;

      const title = modal.querySelector('[data-upsell-modal-title]');
      const originalPrice = modal.querySelector('[data-upsell-modal-original]');
      const offerPrice = modal.querySelector('[data-upsell-modal-offer]');
      const gallery = modal.querySelector('[data-upsell-gallery]');
      const dots = modal.querySelector('[data-upsell-dots]');
      const sizes = modal.querySelector('[data-upsell-sizes]');
      const selectedSize = modal.querySelector('[data-upsell-selected-size]');
      const checkoutButton = modal.querySelector('[data-upsell-checkout]');
      const error = modal.querySelector('[data-upsell-error]');

      title.textContent = product.title;
      originalPrice.textContent = this.formatMoney(product.price);
      offerPrice.textContent = this.formatMoney(product.offerPrice);
      selectedSize.textContent = 'Selecione';
      checkoutButton.disabled = true;
      checkoutButton.textContent = this.dataset.checkoutButtonText || 'Aproveitar oferta';
      error.hidden = true;
      error.textContent = '';

      gallery.innerHTML = '';
      dots.innerHTML = '';

      product.images.forEach((image, index) => {
        const slide = document.createElement('div');
        const img = document.createElement('img');

        slide.className = 'alto-upsell-modal__slide';
        img.src = image.src;
        img.alt = image.alt || product.title;
        img.loading = index === 0 ? 'eager' : 'lazy';
        slide.appendChild(img);
        gallery.appendChild(slide);

        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'alto-upsell-modal__dot' + (index === 0 ? ' is-active' : '');
        dot.dataset.upsellDot = String(index);
        dot.setAttribute('aria-label', 'Ver imagem ' + (index + 1));
        dots.appendChild(dot);
      });

      const galleryButtons = modal.querySelectorAll('[data-upsell-prev], [data-upsell-next]');
      galleryButtons.forEach((galleryButton) => {
        galleryButton.hidden = product.images.length < 2;
      });
      dots.hidden = product.images.length < 2;

      sizes.innerHTML = '';
      product.variants.forEach((variant) => {
        const size = document.createElement('button');
        size.type = 'button';
        size.className = 'alto-upsell-modal__size';
        size.dataset.upsellSize = '';
        size.dataset.variantId = String(variant.id);
        size.textContent = variant.size === 'Default Title' ? 'Único' : variant.size;
        size.disabled = !variant.available;
        size.setAttribute('aria-pressed', 'false');
        sizes.appendChild(size);
      });

      if (this.galleryController) this.galleryController.abort();
      this.galleryController = new AbortController();
      let scrollFrame = null;

      gallery.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
          this.updateSlideState(index);
        });
      }, { passive: true, signal: this.galleryController.signal });

      gallery.scrollLeft = 0;
    }

    selectVariant(variantId) {
      if (!this.activeProduct) return;

      const variant = this.activeProduct.variants.find((item) => Number(item.id) === Number(variantId));
      if (!variant || !variant.available) return;

      this.selectedVariant = variant;

      this.modal.querySelectorAll('[data-upsell-size]').forEach((button) => {
        const selected = Number(button.dataset.variantId) === Number(variant.id);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      const selectedSize = this.modal.querySelector('[data-upsell-selected-size]');
      const checkoutButton = this.modal.querySelector('[data-upsell-checkout]');
      selectedSize.textContent = variant.size === 'Default Title' ? 'Único' : variant.size;
      checkoutButton.disabled = false;

      if (variant.image) {
        const imageIndex = this.activeProduct.images.findIndex((image) => image.src === variant.image);
        if (imageIndex >= 0) this.showSlide(imageIndex);
      }
    }

    showSlide(index) {
      const gallery = this.modal && this.modal.querySelector('[data-upsell-gallery]');
      const total = this.activeProduct ? this.activeProduct.images.length : 0;

      if (!gallery || total < 1) return;

      const normalizedIndex = (index + total) % total;
      gallery.scrollTo({ left: normalizedIndex * gallery.clientWidth, behavior: 'smooth' });
      this.updateSlideState(normalizedIndex);
    }

    updateSlideState(index) {
      this.currentSlide = index;

      if (!this.modal) return;
      this.modal.querySelectorAll('[data-upsell-dot]').forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    async copyCoupon(button, quiet) {
      const coupon = this.dataset.coupon || '';
      if (!coupon) return false;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(coupon);
        } else {
          const input = document.createElement('textarea');
          input.value = coupon;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        }

        if (button && !quiet) {
          const originalText = button.dataset.originalText || button.textContent;
          button.dataset.originalText = originalText;
          button.textContent = 'Copiado';
          window.setTimeout(() => { button.textContent = originalText; }, 1800);
        }
        return true;
      } catch (error) {
        console.warn('[Alto Upsell] Não foi possível copiar o cupom.', error);
        return false;
      }
    }

    async startYampiCheckout(button) {
      if (this.checkoutBusy || !this.selectedVariant) return;

      if (this.dataset.offerExpired === 'true' && this.dataset.disableAfterCountdown === 'true') {
        this.showError('Esta condição expirou. Atualize a página para consultar as ofertas disponíveis.');
        return;
      }

      this.checkoutBusy = true;
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Preparando seu checkout...';
      this.showError('');

      await this.copyCoupon(null, true);

      if (typeof window.showYampiLoader === 'function') {
        window.showYampiLoader();
      }

      try {
        await this.shopifyRequest('/cart/clear.js', {});
        await this.shopifyRequest('/cart/add.js', {
          items: [{ id: Number(this.selectedVariant.id), quantity: 1 }]
        });

        const cartResponse = await fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        if (!cartResponse.ok) throw new Error('Não foi possível preparar o item selecionado.');
        const cart = await cartResponse.json();

        const yampiResponse = await fetch(this.dataset.yampiEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            shop: window.location.host,
            shopify_internal_domain: this.dataset.shopifyDomain,
            cart_payload: cart
          })
        });

        if (!yampiResponse.ok) throw new Error('O checkout externo não respondeu.');
        const yampi = await yampiResponse.json();

        if (!yampi.active || !yampi.checkout_direct_url) {
          throw new Error('O checkout externo está indisponível neste momento.');
        }

        try {
          await this.shopifyRequest('/cart/clear.js', {});
        } catch (clearError) {
          console.warn('[Alto Upsell] O checkout foi criado, mas o carrinho temporário não foi limpo.', clearError);
        }

        const checkoutUrl = typeof window.ymp_getUrlWithUtms === 'function'
          ? window.ymp_getUrlWithUtms(yampi.checkout_direct_url)
          : yampi.checkout_direct_url;

        window.location.assign(checkoutUrl);
      } catch (error) {
        console.error('[Alto Upsell] Falha ao abrir o checkout Yampi.', error);
        this.showError(error.message || 'Não foi possível abrir o checkout. Tente novamente.');
        this.checkoutBusy = false;
        button.disabled = false;
        button.textContent = originalText;

        if (typeof window.hideYampiLoader === 'function') {
          window.hideYampiLoader();
        }
      }
    }

    async shopifyRequest(url, body) {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        let message = 'Não foi possível preparar o produto.';

        try {
          const payload = await response.json();
          message = payload.description || payload.message || message;
        } catch (error) {
          // Keep the user-facing fallback when Shopify returns a non-JSON error.
        }
        throw new Error(message);
      }

      return response.json();
    }

    showError(message) {
      const error = this.modal && this.modal.querySelector('[data-upsell-error]');
      if (!error) return;

      error.textContent = message;
      error.hidden = !message;
    }

    formatMoney(cents) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(Number(cents || 0) / 100);
    }

    startCountdown() {
      if (this.dataset.showCountdown !== 'true') return;

      const hours = Math.max(Number(this.dataset.countdownHours) || 12, 1);
      const campaignKey = this.dataset.countdownKey || 'default';
      const storageKey = 'altoUpsellDeadline:' + campaignKey;
      let deadline = 0;

      try {
        deadline = Number(window.localStorage.getItem(storageKey));

        if (!deadline || Number.isNaN(deadline)) {
          deadline = Date.now() + (hours * 60 * 60 * 1000);
          window.localStorage.setItem(storageKey, String(deadline));
        }
      } catch (error) {
        deadline = Date.now() + (hours * 60 * 60 * 1000);
      }

      const update = () => {
        const timer = this.querySelector('[data-upsell-timer]');
        if (!timer) return;

        const remaining = Math.max(deadline - Date.now(), 0);
        const hoursLeft = Math.floor(remaining / 3600000);
        const minutesLeft = Math.floor((remaining % 3600000) / 60000);
        const secondsLeft = Math.floor((remaining % 60000) / 1000);

        timer.textContent = [hoursLeft, minutesLeft, secondsLeft]
          .map((value) => String(value).padStart(2, '0'))
          .join(':');

        if (remaining === 0) {
          this.dataset.offerExpired = 'true';
          timer.textContent = '00:00:00';
          window.clearInterval(this.countdownInterval);

          if (this.dataset.disableAfterCountdown === 'true') {
            this.querySelectorAll('[data-upsell-open]').forEach((button) => { button.disabled = true; });
          }
        }
      };

      update();
      this.countdownInterval = window.setInterval(update, 1000);
    }
  }

  customElements.define('alto-upsell-collection', AltoUpsellCollection);
})();
